import pagination from '@iso/lib/helpers/pagination';

const {
    actions: baseActions,
    types,
    reducer,
} = pagination('productUnits');

const actions = {
    requestFetchProductUnits: baseActions.request,
    fetchProductUnitsSucceeded: baseActions.succeeded,
    fetchProductUnitsFailed: baseActions.failed,
};

export { types, actions };

export default reducer;